import React, { PropsWithChildren, useContext } from 'react'
import { Controller } from 'react-hook-form'
import { FieldContext } from '../constants'
import { FieldControllerContext } from '../stores/context'
import { FieldInputControllerProps } from '../types/Field.types'
import { FieldInput } from './FieldInput'

export const FieldSelectController: React.FC<PropsWithChildren<FieldInputControllerProps>> = ({
  controller,
  errors,
  children
}) => {
  const { isRequired, name, error, helperText, ...otherProps } = useContext(FieldContext)

  const fieldControllerContextValue = { errors }

  return (
    <FieldControllerContext.Provider value={fieldControllerContextValue}>
      <Controller
        name={name || ''}
        control={controller}
        render={({ field: { name, onChange, ...rest }, fieldState }) => {
          const fieldError = fieldState.invalid
          const fieldHelperText = fieldState.error?.message // selaras InputController: dukung path bersarang (lines.0.supplier_id)

          const handleChange = (
            event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | { value: unknown }>
          ) => {
            const newValue = event

            onChange(newValue)
          }

          return (
            <FieldInput fieldError={fieldError} fieldHelperText={fieldHelperText} onChange={handleChange} {...rest}>
              {children}
            </FieldInput>
          )
        }}
      />
    </FieldControllerContext.Provider>
  )
}
